import { MockedRequest, RestHandler, rest } from "msw";

import { CityResponse } from "api/getCitiesByProvince";
import { MOCK_CITIES_BY_PROVINCE } from "mocks/fixtures/citiesByProvinceFixtures";
import { ErrorResponse } from "types/ErrorResponse";

export const getCitiesByProvinceHandler = (
  status: number,
  response: Array<CityResponse> | ErrorResponse
): RestHandler<MockedRequest<Array<CityResponse> | ErrorResponse>> => {
  return rest.get(`/session/digitalJourney/accidentCities`, (_, res, ctx) => {
    return res(ctx.status(status), ctx.json(response));
  });
};

export const citiesByProvinceHandler = [getCitiesByProvinceHandler(200, MOCK_CITIES_BY_PROVINCE)];
